module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_6000.2bb65f31.png";